import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonApp, IonRouterOutlet } from '@ionic/vue';

import { useLocalStorage } from '@/composables/local-storage';
import { useChapterStore } from '@/stores/chapter';
import { useCourseletStore } from '@/stores/courselet';
import { IStoreCourselets, IStoreChapters } from '@/support/interfaces/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const chapterStore = useChapterStore();
const courseletStore = useCourseletStore();

chapterStore.$patch({
  chapters: useLocalStorage('chapters', {}).value as IStoreChapters,
});

courseletStore.$patch({
  courselets: useLocalStorage('courselets', {}).value as IStoreCourselets,
});

chapterStore.$subscribe(
  (mutation, state) => {
    if (mutation.type === 'direct') {
      useLocalStorage('chapters').value = state.chapters;
    }
  },
  { detached: true }
);

courseletStore.$subscribe(
  (mutation, state) => {
    if (mutation.type === 'direct') {
      useLocalStorage('courselets').value = state.courselets;
    }
  },
  { detached: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})